import React from 'react'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Grid } from '@material-ui/core'
import {
  ButtonHLPure,
  DataPickerHLPure,
  TextAreaHLPure,
  InputHLPure,
  CheckBoxHLPure,
  DropDownBtnHLPure,
} from '../../pures'
import './dialogContractor.css'
import { useTranslation } from 'react-i18next'


const DialogContractor = (props) => {
  const {
    titleDialog,
    cancel,
    cancelName,
    limitDate,
    limitMaxDate,
    labelDataPicker,
    stateDate,
    stateNameContractor,
    labelNameInput,
    stateEmailContractor,
    labelEmailInput,
    stateNotesContractor,
    myselfRegisterState,
    onChangeNameContractor,
    onChangeEmailContractor,
    onChangeMyselfRegister,
    onChangeNotesContractor,
    onChangeDateContractor,
    onTypePersonChange,
    personTypeLabel,
    contractorsTypeOptions,
    valueOptionDropdown,
    nameOptionDropdown,
    onErrorDateState,
    onEmailErrorState,
    handleSubmit,
    submitName,
    companies,
    filterChangeCompanies,
    companyFilerSelected,
    showCompanyDrop,
    onErrorNameState,
    onErrorPersonTypeState,
    onErrorCompanyState,
    onErrorDateRangeState
  } = props

  const { t } = useTranslation()

  return (
    <Dialog
      className='dialogContractor-container'
      width={600}
      height={560}
      title={titleDialog}
      onClose={cancel}
    >
      <div>
        <Grid container className='dialogContractor-body-container'>
          <Grid
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
          >
            <InputHLPure
              labelInput={labelNameInput}
              valueInput={stateNameContractor}
              inputActive
              required
              handleChangeInput={onChangeNameContractor}
            />
            {onErrorNameState ? (
              <span className='hint-message-error'>
                {t('contractorsCatalogView.error.name.contractor')}
              </span>
            ) : null}
          </Grid>
          <Grid
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className='dialogContractor-dropdownContractorDialog'
          >
            <DropDownBtnHLPure
              required
              labelDropDown={personTypeLabel}
              onDropDownChange={onTypePersonChange}
              optionsDropDown={contractorsTypeOptions}
              valueItem={valueOptionDropdown}
              nameOption={nameOptionDropdown}
            />
            {onErrorPersonTypeState ? (
              <span className='hint-message-error'>
                {t('contractorsCatalogView.error.person.contractor')}
              </span>
            ) : null}
          </Grid>
          {
            showCompanyDrop ? (
              <Grid
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className='dialogContractor-dropdownContractorDialog'
              >
                <DropDownBtnHLPure
                  required
                  labelDropDown={t('dialogContractor.title.company')}
                  optionsDropDown={companies}
                  onDropDownChange={(e) => filterChangeCompanies(e)}
                  optionsValue={companyFilerSelected}
                  valueItem={'id'}
                  nameOption={'name'}
                />
                {onErrorCompanyState ? (
                  <span className='hint-message-error'>
                    {t('contractorsCatalogView.error.business.contractor')}
                  </span>
                ) : null}
              </Grid>
            ) : null
          }
          <Grid
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
          // className='dialogContractor-inputForContractorDialog'
          >
            <InputHLPure
              required
              disabled={myselfRegisterState}
              setSpace
              labelInput={labelEmailInput}
              valueInput={stateEmailContractor}
              inputActive
              extraContent={
                <CheckBoxHLPure
                  setReverse
                  labelCheckBox={t('dialoContractor.title.illDoRegistration')}
                  checkedState={myselfRegisterState}
                  onChangeHandler={onChangeMyselfRegister}
                />
              }
              handleChangeInput={onChangeEmailContractor}
            />
            {onEmailErrorState ? (
              <span className='hint-message-error'>
                {t('contractorsCatalogView.error.email.contractor')}
              </span>
            ) : null}
          </Grid>
          <Grid
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className='dialogContractor-datePicker'
          >
            <DataPickerHLPure
              required
              labelDataPicker={labelDataPicker}
              valueDate={stateDate}
              limitDate={limitDate}
              maxDate={limitMaxDate}
              handleChangeDate={onChangeDateContractor}
            />
            {onErrorDateState ? (
              <span className='hint-message-error'>
                {t('contractorsCatalogView.error.date.contractor')}
              </span>
            ) : null}
            {onErrorDateRangeState ? (
              <span className='hint-message-error'>
                {t('contractorsCatalogView.error.range.contractor')}
              </span>
            ) : null}
          </Grid>
          <Grid
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
          // className='dialogContractor-inputForContractorDialog'
          >
            <TextAreaHLPure
              labelTextArea={t('dialoContractor.title.notes')}
              handleChangeTextArea={onChangeNotesContractor}
              valueTextData={stateNotesContractor}
            />
          </Grid>
          <Grid
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className='dialogContractor-btns-container'
          >
            <ButtonHLPure
              nameBtn={cancelName}
              onClickBtn={cancel}
              primary={false}
            />
            <ButtonHLPure
              primary={true}
              nameBtn={submitName}
              onClickBtn={handleSubmit}
            />
          </Grid>
        </Grid>
      </div>
    </Dialog>
  )
}

export { DialogContractor as default }
